"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RemoveApiKeyModalContainer = _interopRequireDefault(require("../RemoveApiKeyModal/RemoveApiKeyModalContainer"));
var _APTable = _interopRequireDefault(require("../../common/APTable"));
var _APIcon = _interopRequireDefault(require("../../common/APIcon"));
var _lodash = require("lodash");
var _CancelAPButton = _interopRequireDefault(require("../../common/CancelAPButton"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./ApiKeyListComponent.css");
var _EditApiKeyWhitelistIpAddressesContainer = _interopRequireDefault(require("../EditApiKeyWhitelistIpAddresses/EditApiKeyWhitelistIpAddressesContainer"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ApiKeyListComponent = function ApiKeyListComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var baseClasses = (0, _cssClassesHelper.getBEMClasses)('api-key-list', props.customClass);
  var formatPermissionValue = function formatPermissionValue(permissions, permissionName) {
    return permissions.indexOf(permissionName) !== -1 ? /*#__PURE__*/_react["default"].createElement("p", {
      className: baseClasses('check')
    }, "\u2713") : '';
  };
  var columns = [{
    header: t("Key"),
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('text-item')
      }, props.customClass && /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "bigKey",
        customClass: baseClasses('icon')
      }), row.APIKey);
    }
  }, {
    header: t("IP Whitelist"),
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          return props.editApiKeyWhitelistIpAddresses(row);
        }
      }, !(0, _lodash.isEmpty)(row.IpWhiteList) ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "api-key-list__edit"
      }, row.IpWhiteList) : /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: "api-key-list__edit--button",
        styleName: "additive"
      }, t("Add")));
    }
  }, {
    header: t("Allows Deposits"),
    cell: function cell(row) {
      return formatPermissionValue(row.Permissions, 'Deposit');
    }
  }, {
    header: t("Allows Withdraws"),
    cell: function cell(row) {
      return formatPermissionValue(row.Permissions, 'Withdraw');
    }
  }, {
    header: t("Allows Trading"),
    cell: function cell(row) {
      return formatPermissionValue(row.Permissions, 'Trading');
    }
  }, {
    header: t("Read-only"),
    cell: function cell(row) {
      return formatPermissionValue(row.Permissions, 'AccountReadOnly');
    }
  }, {
    header: '',
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement(_CancelAPButton["default"], {
        customClass: baseClasses(),
        text: t("Delete"),
        onClick: function onClick() {
          return props.removeApiKey(row.APIKey);
        }
      });
    }
  }];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement(_APTable["default"], {
    componentName: 'ApiKeysComponent',
    columns: columns,
    rows: props.apiKeys,
    baseClass: baseClasses,
    headerOutside: true,
    empty: t("No data is available")
  }), /*#__PURE__*/_react["default"].createElement(_RemoveApiKeyModalContainer["default"], null), /*#__PURE__*/_react["default"].createElement(_EditApiKeyWhitelistIpAddressesContainer["default"], null));
};
ApiKeyListComponent.propTypes = {
  apiKeys: _propTypes["default"].array.isRequired,
  removeApiKey: _propTypes["default"].func.isRequired,
  editApiKeyWhitelistIpAddresses: _propTypes["default"].func.isRequired,
  customClass: _propTypes["default"].string
};
var _default = exports["default"] = ApiKeyListComponent;